/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/canvas_step_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/canvas_step_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  canvas_id: common.objectId.nullable().optional(),
  step_type: z.literal("MESSAGE").nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/canvas_step_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  canvas_id: common.objectId,
  step_type: z.literal("MESSAGE"),
});
